module.exports = __webpack_public_path__ + "img/look.66a67d2a.svg";